import { ComponentPortal, DomPortal, TemplatePortal } from '@angular/cdk/portal';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { Subscription } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { delay, map, tap } from 'rxjs/operators';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
type Portal = TemplatePortal | ComponentPortal<any> | DomPortal;
export const DATA_TOKEN = new InjectionToken<string>('portal-data');
export interface PortalDataResult {
  data?: any,
  manualClose?: boolean,
  type?: any
}
export interface CDKPortalComponent {
  close: EventEmitter<any>,
  results: EventEmitter<PortalDataResult | any>,
}
export interface ICDKPortalComponent {
  close: EventEmitter<any>,
  results: EventEmitter<PortalDataResult | any>,
}
@Injectable({
  providedIn: 'root'
})
export class ZenCDKService {
  private modalOverlay: OverlayRef = this.overlay.create({});

  private componentRef: any;

  subscribtion: Subscription;
  constructor(private overlay: Overlay, private injector: Injector) {
    this.modalOverlay = this.overlay.create();
  }
  openComponent(component, data?) {
    
    const portalData = Injector.create({
      providers: [{ provide: DATA_TOKEN, useValue: data }],
      parent: this.injector
    });
    if (this.modalOverlay.hasAttached()) {
      this.modalOverlay.detach();
    }
    this.componentRef = this.modalOverlay.attach(new ComponentPortal(component, null, portalData));
    this.componentRef.instance.myInput = data;
    const subscribtion: Subscription = this.componentRef.instance.close.subscribe((val: any) => {
      this.modalOverlay.detach();
      subscribtion.unsubscribe();
    });
    return this.componentRef.instance.results.pipe(delay(300), tap((val: any) => {
      if (!val?.manualClose) {
        this.modalOverlay.detach();
      }
    }), map(x => x));
  }

  closeAll() {
    this.modalOverlay.detach();
  }

  open(component, data?) {
    const portalData = Injector.create({
      providers: [{ provide: DATA_TOKEN, useValue: data }],
    });
    const overlay = this.overlay.create();
    let componentRef: any = overlay.attach(new ComponentPortal(component, null, portalData));
    componentRef.instance['myInput'] = data;
    const subscribtion: Subscription = componentRef.instance.close.subscribe((val: any) => {
      overlay.detach();
      subscribtion.unsubscribe();
    });
    return componentRef.instance.results.pipe(delay(300), tap((val: any) => {
      if (!val?.manualClose) {
        overlay.detach();
      }
    }), map(x => x));
  }



}
